module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ul-tree"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.toggle(_vm.data.name, _vm.data.id, _vm.data.children, _vm.data.depth)
      }
    }
  }, [_vm._v(_vm._s(_vm.data.name)), (_vm.isFolder && _vm.data.children) ? _c('Icon', {
    attrs: {
      "type": _vm.open ? 'chevron-down' : 'chevron-right',
      "size": "12"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isFolder) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "aside-sub-nav-menu"
  }, _vm._l((_vm.data.children), function(item) {
    return _c('ul-tree', {
      key: item.id,
      attrs: {
        "data": item
      }
    })
  }), 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bd377fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ul_tree.vue
// module id = 489
// module chunks = 15